export default __webpack_public_path__ + "static/media/TEDDY.72430752.png";